import { Body2, makeStyles, Persona } from "@fluentui/react-components";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { SkeletonChat } from "./skeletonChat/SkeletonChat";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        gap: "10px"
    },
    persona: {
        padding: "10px 20px 10px 10px",
        wordBreak: "break-word"
    },
    markDown: {
        width: "100%"
    }
});

export interface IAIResponseProps {
    aiMessage: string | null;
    isLoading: boolean;
};

export const AIResponse = (props: IAIResponseProps): JSX.Element => {
    const styles = useStyles();

    if (props.isLoading) return <SkeletonChat />;
    if (!props.aiMessage) return <></>;

    return (
        <div className={styles.container}>
            <Persona
                name="NorthHighland AI"
                secondaryText="assistant"
                size="large"
                avatar={{ image: { src: "/images/logo_sm.png" } }}
            />
            <Body2 className={styles.persona}>
                <Markdown className={styles.markDown} remarkPlugins={[remarkGfm]}>
                    {props.aiMessage}
                </Markdown>
            </Body2>
        </div>
    );
}; 